import { useMutation } from '@apollo/client/react';

import { RepoUploadInitDocument } from 'src/graphql/actions/repoUploads/secureUploadInit.mutation';
import { RepoUploadCompleteDocument } from 'src/graphql/actions/repoUploads/completeRepoUpload.mutation';
import { RepoUploadCancelDocument } from 'src/graphql/actions/repoUploads/repoUploadCancel.mutation';

import useRepoUploadFlow from './use-repo-upload-flow';

const useRepoUploads = (escrowId: string) => {
  const [initRepoUpload] = useMutation(RepoUploadInitDocument);
  const [completeRepoUpload] = useMutation(RepoUploadCompleteDocument);
  const [cancelRepoUpload] = useMutation(RepoUploadCancelDocument);

  return useRepoUploadFlow(escrowId, {
    init: async ({ numParts, filename, repoName, assetId }) => {
      const { data } = await initRepoUpload({
        variables: { softwareEscrowId: escrowId, numParts, filename, repoName, assetId },
      });

      return { uploadId: data?.repoUploadInit?.uploadId, uploadUrls: data?.repoUploadInit?.uploadUrls };
    },
    complete: async ({ uploadId, parts, size, contentType, repoName, assetId }) => {
      const { data } = await completeRepoUpload({
        variables: { softwareEscrowId: escrowId, uploadId, parts, size, contentType, repoName, assetId },
      });

      return { assetId: data?.repoUploadComplete?.asset?.id ?? null };
    },
    cancel: ({ uploadId, assetId }) =>
      cancelRepoUpload({ variables: { softwareEscrowId: escrowId, uploadId, assetId } }),
  });
};

export default useRepoUploads;
